import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { IUser } from 'src/app/core/models/user.model';
import { QuestionnairesService } from './questionnaires.service';
import { AuthState } from 'src/app/core/store/auth/auth.state';
import { Store } from '@ngrx/store';
import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { QuestionariType } from '../model/questionnaire-response';
import { ErrorType } from 'src/app/shared/enums/error';
import { Errors } from 'src/app/shared/enums/error';

@Injectable({
  providedIn: 'root'
})
export class AllergiesCommorbiditiesService {
  private patientSelectedId: string | null = null;
  private allergiesCommorbsSubject = new BehaviorSubject<any>(null);

  subscription!: Subscription;
  userLogged: IUser | null = null;

  constructor(
    private questionnairesService: QuestionnairesService,
    private store: Store<AuthState>,
    private patientInfoService: PatientService
  ) {
    this.allergiesCommorbsSubject.next(null);

    this.subscription = (
      combineLatest([
        this.store.select(getAuthStateSelect),
        this.patientInfoService.getPatientId()
      ])
        .subscribe(([auth, patientId]) => {
          if (!auth.user || !patientId) return;

          this.userLogged = auth.user;
          this.patientSelectedId = patientId;
        }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get getAllergiesCommorbs() {
    return this.allergiesCommorbsSubject.asObservable();
  }

  async loadAllergiesCommorbs(patientId: string, user: IUser): Promise<void> {

    this.allergiesCommorbsSubject.next(null);
    await this.questionnairesService.getQuestionnaires(
      'allergiesComorbidities', patientId, user.practitionerId)
      .then((result: any) => {
        if (result) {
          this.allergiesCommorbsSubject.next({
            ...result,
            history: [...(result?.history ?? [])],
            myclinicHistory: [...(result?.myclinicHistory ?? [])],
            today: { ...result?.today }
          });
        }
      });
  }

  async saveAllergiesCommorbs({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.saveNewQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadAllergiesCommorbs(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao salvar questionário de alergias e comorbidades.',
        error
      );
    }
  }

  async updateAllergiesCommorbs({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.updateQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadAllergiesCommorbs(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao atualizar questionário de alergias e comorbidades.',
        error
      );
    }
  }
}
